import React from 'react';
import { useNavigate } from 'react-router-dom';

const VOID_BG = '#080810';
const CYAN = '#00FFE5';
const ICE = '#E8F4FF';
const MUTED = '#8899AA';
const MONO = "'JetBrains Mono', 'Courier New', monospace";
const ORBITRON = "'Orbitron', monospace";

const NotFound = () => {
  const navigate = useNavigate();

  return (
    <div className="min-h-screen flex flex-col items-center justify-center p-4 page-fade-in" style={{ background: VOID_BG, color: ICE, fontFamily: MONO }}>
      <div className="text-center max-w-md">
        <div className="flex justify-center mb-6">
          <h1 style={{ fontFamily: ORBITRON, fontWeight: 900, fontSize: '8rem', color: 'rgba(0,255,229,0.15)', lineHeight: 1, letterSpacing: '0.1em' }}>404</h1>
        </div>
        <h2 style={{ fontFamily: ORBITRON, fontWeight: 700, fontSize: '1.2rem', color: ICE, marginBottom: '0.75rem', letterSpacing: '0.1em' }}>
          SECTOR NOT FOUND
        </h2>
        <p style={{ color: MUTED, fontSize: '0.82rem', fontFamily: MONO, marginBottom: '2.5rem', lineHeight: 1.7 }}>
          This coordinate does not exist in the RecallCore network.<br />
          Return to base and try again.
        </p>
        <div className="flex flex-col sm:flex-row gap-4 justify-center">
          <button onClick={() => window.history?.back()}
            style={{ background: 'transparent', border: `1px solid rgba(0,255,229,0.4)`, color: CYAN, padding: '10px 24px', fontFamily: MONO, fontWeight: 700, fontSize: '0.75rem', letterSpacing: '0.1em', textTransform: 'uppercase', cursor: 'pointer', display: 'flex', alignItems: 'center', gap: '8px', justifyContent: 'center' }}
            onMouseEnter={e => e.currentTarget.style.borderColor = CYAN}
            onMouseLeave={e => e.currentTarget.style.borderColor = 'rgba(0,255,229,0.4)'}>
            ← GO BACK
          </button>
          <button onClick={() => navigate('/')}
            style={{ background: CYAN, color: VOID_BG, padding: '10px 24px', fontFamily: MONO, fontWeight: 700, fontSize: '0.75rem', letterSpacing: '0.1em', textTransform: 'uppercase', border: 'none', cursor: 'pointer', display: 'flex', alignItems: 'center', gap: '8px', justifyContent: 'center' }}
            onMouseEnter={e => e.currentTarget.style.opacity = '0.85'}
            onMouseLeave={e => e.currentTarget.style.opacity = '1'}>
            ⌂ RETURN TO BASE
          </button>
        </div>
      </div>
    </div>
  );
};

export default NotFound;
